import {
  ECustomRangeType,
  TAbsoluteTimeUnit,
  TRelativeTimeUnit, TSkipButtonTranslations,
} from '@/components/date-range-picker/date-range-picker.ts';

const timeUnits: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: 'Date',
  days: 'Day | Days',
  hours: 'Hour | Hours',
  isoWeek: 'Calendar week | Calendar weeks',
  minutes: 'Minute | Minutes',
  months: 'Month | Months',
  quarters: 'Quarter | Quarters',
  weeks: 'Week | Weeks',
  years: 'Year | Years',
};

const timeUnitsShort: Record<TRelativeTimeUnit | TAbsoluteTimeUnit, string> = {
  day: '',
  days: 'd',
  hours: 'h',
  isoWeek: 'CW',
  minutes: 'min',
  months: 'm',
  quarters: 'Q',
  weeks: 'w',
  years: 'y',
};

const header: Record<ECustomRangeType, string> = {
  [ECustomRangeType.ABSOLUTE]: 'Absolute',
  [ECustomRangeType.CUSTOM]: 'Custom',
  [ECustomRangeType.RELATIVE]: 'Relative',
  [ECustomRangeType.BY_JOB]: 'By job',
};

const skipButtonTranslations: TSkipButtonTranslations = {
  next: 'Move {formattedDuration} ahead, to {to}',
  previous: 'Move {formattedDuration} back, to {to}',
};

const skipButtonTranslationsByJob: TSkipButtonTranslations = {
  next: 'Move to the next job',
  previous: 'Move to the previous job',
};

const directions: Record<'past' | 'future', string> = {
  past: 'Past',
  future: 'Future',
};

export default {
  header,
  jobLabel: 'Job',
  lastJobLabel: 'Last job',
  useLastJob: 'Use last job',
  convertToCustom: 'Convert to custom',
  custom: 'Custom',
  currentWeek: 'current week',
  previousWeek: 'last week',
  nextWeek: 'next week',
  calendarWeek: 'CW',
  rangeInvalidHint: 'The selected time period is either greater than the maximum allowable duration {maxDuration} or the chosen dates are outside the permitted range of {minDate} - {maxDate}.',
  rangeFrom: 'From',
  rangeTo: 'To',
  timeUnit: 'Time unit',
  all: 'All',
  timeUnits,
  timeUnitsShort,
  skipButtonTranslations,
  skipButtonTranslationsByJob,
  directions,
};
